import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";

export const StyledImageBox = styled(FlexDiv)`
  overflow: hidden;
  user-select: none;
  img {
    max-height: 100%;
    margin: 0 auto;
    ${({ objectFit }) =>
      objectFit !== "unset" &&
      `
        object-fit:${objectFit};
    `}
  }
`;
